export default __webpack_public_path__ + "static/posrightplain-690a069e7c55f53a8feb79ec435f8dea.svg";